

































































































































import VueOptions from '@utils/VueOptions'

settings = 
  name: 'SponsorDayOfEventDisplay'
  vue: 
    props: ['report']
    computed: 
      venueUrl: -> 
        "https://www.google.com/maps/search/?api=1&query=#{@report.event.venue.lat},#{@report.event.venue.lng}&zoom=14" if @report
export default VueOptions.vue settings
